import React from 'react';
import { useLocation } from '@reach/router';
import { Layout } from './Layout';
import { Header } from './Header';
import { Footer } from './Footer';
import { ContactFormModal } from './ContactFormModal';
import { DonationModal } from './DonationModal';
import { ToastProvider } from '../context/ToastContext';
import { UtmProvider } from '../context/UtmContext';
import { useModal } from '../hooks/useModal';
import NewsSection from './NewsSection';

interface AppWrapperProps {
  children: React.ReactNode;
}

export const AppWrapper: React.FC<AppWrapperProps> = ({ children }) => {
  const {
    isContactModalOpen,
    closeContactModal,
    isDonationModalOpen,
    closeDonationModal,
  } = useModal();
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '';

  return (
    <UtmProvider>
      <ToastProvider>
        <Layout>
          {isHomePage && (
            <div className='hidden md:block'>
              <NewsSection />
            </div>
          )}
          <div className='relative'>
            <Header />
            {isHomePage && (
              <div className='block md:hidden'>
                <NewsSection />
              </div>
            )}
            {children}
          </div>
          <Footer />
        </Layout>

        <ContactFormModal
          isOpen={isContactModalOpen}
          onClose={closeContactModal}
        />
        <DonationModal
          isOpen={isDonationModalOpen}
          onClose={closeDonationModal}
        />
      </ToastProvider>
    </UtmProvider>
  );
};
